import axios from "axios";
import authHeader from "./auth-header";
import { BASE_URL } from "./config";

// ******* TEAM CHAT ******************************************************************************************************

export const getGeneral = () => {
  try {
    return axios.get(BASE_URL + "team/getGeneral", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getConversations = () => {
  try {
    return axios.get(BASE_URL + "team/getConversations", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getOrCreateDM = (target_uuid) => {
  try {
    return axios.post(
      BASE_URL + "team/getOrCreateDM",
      { target_uuid },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const createGroup = (name, member_uuids) => {
  try {
    return axios.post(
      BASE_URL + "team/createGroup",
      { name, member_uuids },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getTeamMessages = (team_id, before = null, limit = 50) => {
  try {
    let url =
      BASE_URL + "team/getMessages?team_id=" + team_id + "&limit=" + limit;
    if (before) url += "&before=" + before;
    return axios.get(url, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getTeamMembers = (team_id) => {
  try {
    return axios.get(BASE_URL + "team/getMembers?team_id=" + team_id, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const addTeamMembers = (team_id, member_uuids) => {
  try {
    return axios.post(
      BASE_URL + "team/addMembers",
      { team_id, member_uuids },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const leaveGroup = (team_id) => {
  try {
    return axios.post(
      BASE_URL + "team/leaveGroup",
      { team_id },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const searchTeamUsers = (q, exclude_team_id = "") => {
  try {
    let url = BASE_URL + "team/searchUsers?q=" + encodeURIComponent(q);
    if (exclude_team_id) url += "&exclude_team_id=" + exclude_team_id;
    return axios.get(url, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

// ******* BATCH A — Pins, Search, Emoji Frequency ****************************************

export const getPinnedMessages = (team_id) => {
  try {
    return axios.get(BASE_URL + "team/getPinnedMessages?team_id=" + team_id, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const searchMessages = (q, team_id = "") => {
  try {
    let url = BASE_URL + "team/searchMessages?q=" + encodeURIComponent(q);
    if (team_id) url += "&team_id=" + team_id;
    return axios.get(url, {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const getEmojiFrequency = () => {
  try {
    return axios.get(BASE_URL + "team/getEmojiFrequency", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

// ******* BATCH B — Avatar, Notification Preferences *************************************

export const getAvatarSettings = () => {
  try {
    return axios.get(BASE_URL + "team/getAvatarSettings", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const updateAvatarSettings = (
  avatar_mode,
  avatar_color,
  avatar_url = "",
) => {
  try {
    return axios.post(
      BASE_URL + "team/updateAvatarSettings",
      { avatar_mode, avatar_color, avatar_url },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getAvatarsBulk = (uuids) => {
  try {
    return axios.post(
      BASE_URL + "team/getAvatarsBulk",
      { uuids },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getNotificationPrefs = () => {
  try {
    return axios.get(BASE_URL + "team/getNotificationPrefs", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const muteConversation = (team_id, muted) => {
  try {
    return axios.post(
      BASE_URL + "team/muteConversation",
      { team_id, muted },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const archiveConversation = (team_id, archived) => {
  try {
    return axios.post(
      BASE_URL + "team/archiveConversation",
      { team_id, archived },
      { headers: authHeader() },
    );
  } catch (e) {
    console.log(e);
  }
};

export const getArchivedConversations = () => {
  try {
    return axios.get(BASE_URL + "team/getArchivedConversations", {
      headers: authHeader(),
    });
  } catch (e) {
    console.log(e);
  }
};

export const uploadTeamFiles = (team_id, files) => {
  try {
    const formData = new FormData();
    formData.append("team_id", team_id);
    for (const file of files) {
      formData.append("files", file);
    }
    return axios.post(BASE_URL + "team/uploadFile", formData, {
      headers: {
        ...authHeader(),
        "Content-Type": "multipart/form-data",
      },
    });
  } catch (e) {
    console.log(e);
  }
};

export const getFileUrl = (team_id, s3_key) => {
  try {
    return axios.get(BASE_URL + "team/getFileUrl", {
      headers: authHeader(),
      params: { team_id, s3_key },
    });
  } catch (e) {
    console.log(e);
  }
};
